import { Component, input, model, output } from '@angular/core';
import { faMinus, faPlus } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'eiq-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss', '_counter-theme.component.scss']
})
export class CounterComponent {
  maxValue = input<number>(null);
  testId = input<string>();
  value = model<number>(0);

  setCount = output<number>();

  faMinus = faMinus;
  faPlus = faPlus;
}
